
    import { Component, Mixins, Prop } from 'vue-property-decorator';
    import ListWrapper from '@rogues/ListWrapper/shared/listWrapper';

    @Component({})
    /**
     * @name OneLine
     */
    export default class OneLine extends Mixins(ListWrapper) {
        /**
         * Gutter Space
         * Using UI Helpers as Class
         */
        @Prop({ type: String }) gutters!: string | Array<String>;
    }
